// Shared strings: chrome, components, errors. Copy comes from the prototype
// (prototype/index.html, assets/app.js) and docs/ux-flow.md; anything marked
// DRAFT has no source there and is listed in the w1-02 report.
export default {
  // Chrome
  back: 'Back',
  logoAlt: 'DelayBuddy',
  documentTitle: 'DelayBuddy — check your flight',
  railLabel: 'Progress',
  'rail.E': 'Eligibility',
  'rail.D': 'Details',
  'rail.C': 'Compensation',
  continue: 'Continue',
  close: 'Close',
  edit: 'Edit',

  // Buddy card (decision 9: no reward figure)
  'buddy.title': "Be somebody's Buddy",
  'buddy.body':
    'Everyone on that flight is owed the same, and most of them will never claim it. Share your Buddy link, and you earn when their claim pays out.',
  'buddy.share': 'Share my Buddy link',
  'buddy.copied': 'Buddy link copied',
  'buddy.shareTitle': 'DelayBuddy',
  'buddy.shareText': 'Flight delayed or cancelled? Check what the airline owes you.',

  // Signature pad
  'signature.hint': 'Draw your signature',
  'signature.clear': 'Clear',
  'signature.label': 'Signature',
  'signature.rotate': 'Turning your phone sideways gives you more room to sign.',
  // Q46 typed-name fallback (w5-07). typeInstead and typedAgree are the task's wording;
  // all four are DRAFT until counsel confirms the typed signature.
  'signature.typeInstead': "Can't draw? Type your full name instead", // DRAFT
  'signature.drawInstead': 'Draw my signature instead', // DRAFT
  'signature.typedLabel': 'Your full name', // DRAFT
  'signature.typedAgree': 'I agree this typed name is my signature', // DRAFT
  'signature.typedInvalid': 'Just your name, please: without <, > or %.', // DRAFT

  // Scan / photo zone
  'scan.upload': 'Take a photo or upload',

  // Claim reference board
  'claimRef.label': 'Claim reference {ref}',

  // DRAFT (w5-08): the quiet link at the foot of every screen that reopens the cookie banner.
  cookieSettings: 'Cookie settings',

  // Errors (DRAFT)
  'error.title': 'Something went wrong on our side',
  'error.body': 'Your answers so far are safe. Reload the page, and if it happens again, start a new check.',
  'error.reload': 'Reload the page',
  // DRAFT (w3-03): a stage of the app or a call didn't arrive (offline, a flaky connection).
  'error.offlineTitle': "You're offline",
  'error.offlineBody':
    "We couldn't load the next step. Check your connection and try again — your answers so far are safe.",
  'error.retry': 'Try again',
  // DRAFT (w3-03): the connection dropped; the banner at the top while it's gone.
  offline: "You're offline. We'll carry on as soon as you're back.",
  // DRAFT (w3-03): 429 from the API (too many tries from this connection).
  rateLimited: "That's a lot of tries in a short time. Please wait a few minutes and try again.",
  // DRAFT (w5-11): a guarded call (scan, flight search, upload, link email) failed its bot check twice.
  turnstileFailed: "We couldn't confirm you're not a robot. Please try again.",
  // DRAFT (w5-11): above Cloudflare's widget, when it wants a tap (rare).
  turnstileAsk: "One quick check that you're not a robot:",
  'notFound.title': "We couldn't find that page",
  'notFound.body': 'The link may be incomplete. You can start a new flight check from here.',
  'notFound.cta': 'Check my flight',

  // Placeholder screens (wave 1 only; dev-facing)
  'placeholder.note': 'Placeholder — built in wave 2.',
  'placeholder.next': 'Next: {id}',
  'placeholder.openHandoff': 'Open S11-handoff',
} as const;
